module.exports = __webpack_public_path__ + "img/calendar.b074915a.png";